import React, { useState, useEffect } from 'react';

const JsonTable = (tableData) => {
  const getHeaders = () => {
    if (!tableData || !tableData.data) return [];
    const headers = new Set();
    Object.values(tableData.data || {}).forEach(row => {
      Object.keys(row.parameters).forEach(key => headers.add(key));
    });

    return Array.from(headers);
  };

  const headers = getHeaders();

  return (
    <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '10px', backgroundColor: '#f2f2f2', borderRadius: '0.375rem' }}>
      {Object.keys(tableData.data || {}).length > 0 ? (
        <table border="1" style={{ width: '100%', textAlign: 'left' }}>
          <thead>
            <tr>
              <th>ID</th>
              {headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className='smaller'>
            {Object.values(tableData.data || {}).map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{row.permutationId}</td>
                {headers.map((header, cellIndex) => (
                  <td key={cellIndex}>{row.parameters[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No data to display.</p>
      )}
    </div>
  );
};

export default JsonTable;